module.exports = __webpack_public_path__ + "static/media/banner_desktop_02022024.6f340b66.jpg";